import { Backend } from '@shared/datastore/core';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    giveGetEligibility: boolean;
  }
}

export const giveGetEligibilityBackend: Backend<'giveGetEligibility'> = {
  fetch: () => ({
    endpoint: `users/0.1/referral_invitations/check`,
    params: { bonus_id: '16' },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/give-get-eligibility/give-get-eligibility.backend.ts